import React, { useCallback, useState, useEffect } from "react";
import { BiEditAlt } from "react-icons/bi";
import { useLocation } from "react-router";
import { CustomButton } from "../../../../components/main_comps/custom_button";
import CustomModal from "../../../../components/main_comps/custom_modal";
import CustomTabs from "../../../../components/main_comps/custom_tabs";
import AlertModals from "../../../../components/ui_comps/AlertModals";
import MainComponent from "../../../../components/ui_comps/MainComponent";
import BankAccountDetails from "../BankAccountDetails";
import BasicDetails from "../BasicDetails";
import ResellerClients from "../ResellerClients";
import ResellerDocument from "../ResellerDocument";
import { useSnackbar } from "notistack";
import {
  RESELLER_DEACTIVATE_ACL,
  RESELLER_EDIT_ACL,
  STATUS_CODE_200,
} from "../../../../../utility/constants/valueConstants";
import { ApiRequestPost } from "../../../../../data/network/services/ApiRequestPost";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { validateEmail } from "../../../../../utility/emailValidator";

const tabs = [
  { name: "Basic Details", key: 0 },
  { name: "Bank account Details", key: 1 },
  { name: "Clients", key: 2 },
  { name: "Documents", key: 3 },
];

const ActionComponent = ({
  editRequired = true,
  onClickDeactivate,
  status,
  onClickEdit,
  isEditClicked,
  onClickSave,
  aclData,
  loading,
  step,
}) => {
  return (
    <div style={{ display: "flex" }}>
      {aclData.includes(RESELLER_DEACTIVATE_ACL) && !isEditClicked && (
        <CustomButton
          styles={{
            backgroundColor: "white",
            border: "1px solid #1E2234",
          }}
          title={status ? "Deactivate account" : "Activate"}
          textStyles={{ color: "#1E2234" }}
          onClick={onClickDeactivate}
        />
      )}

      {editRequired &&
        aclData.includes(RESELLER_EDIT_ACL) &&
        (step === 0 || step === 1) && (
          <>
            <CustomButton
              ionDirection="left"
              icon={
                isEditClicked ? null : <BiEditAlt size={16} color="white" />
              }
              styles={{
                backgroundColor: isEditClicked ? "transparent" : "#38369C",
                border: isEditClicked
                  ? "1px solid #1E2234"
                  : "1px solid #38369C",
                marginLeft: "10px",
              }}
              title={isEditClicked ? "Cancel" : "Edit"}
              textStyles={{ color: isEditClicked ? "#1E2234" : "white" }}
              onClick={onClickEdit}
            />

            {isEditClicked && (
              <CustomButton
                styles={{
                  backgroundColor: "#38369C",
                  border: "1px solid #38369C",
                  marginLeft: "10px",
                }}
                title={"Save"}
                textStyles={{ color: "white" }}
                onClick={onClickSave}
              />
            )}
          </>
        )}
    </div>
  );
};

const ResellerDetailsIndex = () => {
  const [currentTab, setCurrentTab] = useState(0);
  const { state } = useLocation();
  const [openCommissionModal, setOpenCommissionModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [isEditClicked, setIsEditClicked] = useState(false);
  const [clientDetails, setClientDetails] = useState({});
  const aclData = useSelector((state) => state.aclSlice.aclList);

  const handleTabChange = useCallback((tab) => {
    setCurrentTab(tab);
  }, []);
  const navigate = useNavigate();

  const onClickChangeStatus = (
    status,
    userId,
    firstName = "",
    lastName = "",
    mobileNumber = "",
    email = "",
    bankAccountNumber = "",
    bankIfscCode = "",
    nameAsPerBank = ""
  ) => {
    setLoading(true);

    if (mobileNumber && mobileNumber.length != 10) {
      enqueueSnackbar("Invalid Mobile Number", {
        variant: "error",
      });
      return;
    }

    if (email && !validateEmail(email)) {
      enqueueSnackbar("Invalid email id", {
        variant: "error",
      });
      return;
    }

    if (bankAccountNumber && bankAccountNumber.length < 9) {
      enqueueSnackbar("Invalid account Number", {
        variant: "error",
      });
      return;
    }

    if (bankIfscCode && bankIfscCode.length != 11) {
      enqueueSnackbar("Invalid ifsc code", {
        variant: "error",
      });
      return;
    }

    ApiRequestPost.updateReseller({
      status,
      userId,
      email,
      firstName,
      lastName,
      mobileNumber,
      bankAccountNumber,
      bankIfscCode,
      nameAsPerBank,
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(res.message, {
            variant: "success",
          });
          navigate("/reseller");
        } else {
          enqueueSnackbar(res.message, {
            variant: "error",
          });
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    setIsEditClicked(false);
    setClientDetails({});
  }, [currentTab]);

  return (
    <div
      style={{
        width: "100%",
        overflow: "auto",
        boxSizing: "border-box",
        backgroundColor: "white",
      }}
    >
      <MainComponent
        notificationRequired={false}
        filterRequired={false}
        backActionRequired={true}
        headerTitle={state?.data?.firstName + " " + state?.data.lastName}
      />
      <CustomTabs
        tabs={tabs}
        backgroundrequired={false}
        activeIndex={currentTab}
        passCurrentTab={(data) => handleTabChange(data)}
        actionComponent={
          <ActionComponent
            editRequired={currentTab !== 2}
            onClickDeactivate={() => {
              setOpenCommissionModal(true);
            }}
            status={state?.data?.isEnabled}
            step={currentTab}
            onClickEdit={() => {
              setIsEditClicked(!isEditClicked);
            }}
            isEditClicked={isEditClicked}
            aclData={aclData}
            onClickSave={() => {
              onClickChangeStatus(
                "",
                state?.data?.userId,
                clientDetails?.firstName,
                clientDetails?.lastName,
                clientDetails?.mobileNumber,
                clientDetails?.email,
                clientDetails.bankAccountNumber,
                clientDetails.bankIfscCode,
                clientDetails.nameAsPerBank
              );
            }}
          />
        }
      />
      {currentTab === 0 ? (
        <BasicDetails
          data={state?.data}
          isEditClicked={isEditClicked}
          onChange={(val) => {
            setClientDetails({ ...val });
          }}
        />
      ) : currentTab === 1 ? (
        <BankAccountDetails
          data={state?.data}
          isEditClicked={isEditClicked}
          onChange={(val) => {
            setClientDetails({ ...val });
          }}
        />
      ) : currentTab === 2 ? (
        <ResellerClients resellerData={state?.data} />
      ) : (
        <ResellerDocument data={state?.data} />
      )}

      {openCommissionModal && (
        <CustomModal
          headerTitle=""
          open={openCommissionModal}
          onClose={() => {
            setOpenCommissionModal(false);
          }}
          containerStyle={{
            minWidth: 350,
            maxWidth: 450,
            height: "auto",
            maxHeight: 800,
          }}
        >
          <AlertModals
            confirmButtonTitle={"Yes"}
            onClickCancel={() => setOpenCommissionModal(false)}
            onClickOk={(reason) => {
              if (reason) {
                onClickChangeStatus(
                  state?.data?.isEnabled ? false : true,
                  state?.data?.userId
                );
              } else {
                enqueueSnackbar(
                  `Please enter reason for ${
                    state?.data?.isEnabled ? "Deactivate" : "Activate"
                  }`,
                  {
                    variant: "error",
                  }
                );
              }
            }}
            loading={loading}
            role="Reseller"
            action={state?.data?.isEnabled ? "Deactivate" : "Activate"}
            reason={state?.data?.isEnabled ? "Deactivating" : "Activating"}
            isConditional={false}
          />
        </CustomModal>
      )}
    </div>
  );
};

export default ResellerDetailsIndex;
